import React, { useState } from 'react';
import CommonComponent from "../../CommonComponent"
import LoadingButton from "../../../../utility/button/LoadingButton";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { useTranslation } from 'react-i18next';
import capitalize from '../../../../utils/capitalize';

import {
  InputField,
  PasswordField,
  PhoneField,
  SelectField
} from '../../../../utility/form/';
import useUserProfile from './useUserProfile';
import sectorOptions from '../../../Auth/Register/sectors.json';

const UserProfile = () => {
  const { t } = useTranslation();

  const {
    profileForm,
    profileErrors,
    loading,
    passLoading,
    dLoading,
    onProfileChange,
    onProfileSubmit,

    passwordForm,
    passwordErrors,
    onPasswordChange,
    onPasswordSubmit,
    overviewTabRef,
    onCountryCodeChange,
    handleProfileImageChange,
    profileImage
  } = useUserProfile();
  const isImageUrl = typeof profileImage === 'string';

  return (
    <>
      <Breadcrumb  />
      <section className="section profile mt-3">
        <div className="row m-0">
          <div className="col-xl-4">
            <div className="card py-5 justify-content-center">
              <div className="card-bodys profile-card pt-4 pb-3 d-flex flex-column align-items-center position-relative">
                <div className="position-relative">
                  <img
                    src={profileForm.profile_image || "https://bootstrapmade.com/content/demo/NiceAdmin/assets/img/profile-img.jpg"}
                    alt="Profile"
                    className="rounded-circle profile-img"
                  />
                  <div className='profile-upload-circle'>
                  <label htmlFor="profile-image-upload" className="edit-icon-label">
                    <i className="bi bi-pencil edit-icon"></i>
                  </label>
                  </div>
                  <input
                    type="file"
                    id="profile-image-upload"
                    accept="image/*"
                    onChange={handleProfileImageChange}
                    style={{ display: 'none' }}
                  />
                </div>
                <h2>{`${capitalize(profileForm.first_name)} ${capitalize(profileForm.last_name)}`}</h2>
              </div>

            </div>
          </div>

          <div className="col-xl-8">
            <div className="card">
              <div className="card-body pt-4 h-auto">
                <ul className="nav nav-tabs nav-tabs-bordered">
                  <li className="nav-item">
                    <button className="nav-link active ps-0" data-bs-toggle="tab" data-bs-target="#profile-overview" ref={overviewTabRef}>Overview</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-edit">Edit Profile</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-change-password">Change Password</button>
                  </li>
                </ul>

                <div className="tab-content pt-2">
                  <div className="tab-pane fade show active profile-overview mt-1" id="profile-overview">
                    <div className="row"><div className="col-lg-3 col-md-4 label">{t('register.fullName')}</div><div className="col-lg-9 col-md-8 text-muted fw-semibold">{profileForm.first_name + " " + profileForm.last_name }</div></div>
                    <div className="row"><div className="col-lg-3 col-md-4 label">{t('register.email')}</div><div className="col-lg-9 col-md-8 text-muted fw-semibold">{profileForm.email}</div></div>
                    <div className="row"><div className="col-lg-3 col-md-4 label">{t('register.phoneNumber')}</div><div className="col-lg-9 col-md-8 text-muted fw-semibold">{profileForm.phone}</div></div>
                    <div className="row"><div className="col-lg-3 col-md-4 label">{t('register.brandName')}</div><div className="col-lg-9 col-md-8 text-muted fw-semibold">{profileForm.brand_name}</div></div>
                    <div className="row"><div className="col-lg-3 col-md-4 label">{t('register.sector')}</div><div className="col-lg-9 col-md-8 text-muted fw-semibold">{profileForm.sector}</div></div>
                  </div>

                  <div className="tab-pane fade profile-edit pt-3" id="profile-edit">
                    <form onSubmit={onProfileSubmit} noValidate>
                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.firstName')}</label>
                        <div className="col-md-8 col-lg-9">
                          <InputField
                            name="first_name"
                            value={profileForm.first_name}
                            onChange={onProfileChange}
                            error={profileErrors.first_name}
                            placeholder={t('register.firstNamePlaceholder')}
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.lastName')}</label>
                        <div className="col-md-8 col-lg-9">
                          <InputField
                            name="last_name"
                            value={profileForm.last_name}
                            onChange={onProfileChange}
                            error={profileErrors.last_name}
                            placeholder={t('register.lastNamePlaceholder')}
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.email')}</label>
                        <div className="col-md-8 col-lg-9">
                          <InputField
                            name="email"
                            value={profileForm.email}
                            onChange={onProfileChange}
                            error={profileErrors.email}
                            placeholder={t('register.emailPlaceholder')}
                            type="email"
                            disabled={true}
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.phoneNumber')}</label>
                        <div className="col-md-8 col-lg-9">
                        <PhoneField
                          type="tel"
                          name="phone"
                          value={profileForm.phone}
                          onChange={onProfileChange}
                          error={profileErrors.phone}
                          placeholder={t('register.phonePlaceholder')}
                          isPhone={true}
                          country_code={profileForm.country_code}
                          onCountryCodeChange={onCountryCodeChange}
                        />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.brandName')}</label>
                        <div className="col-md-8 col-lg-9">
                          <InputField
                            name="brand_name"
                            value={profileForm.brand_name}
                            onChange={onProfileChange}
                            error={profileErrors.brand_name}
                            placeholder={t('register.brandNamePlaceholder')}
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">{t('register.sector')}</label>
                        <div className="col-md-8 col-lg-9">
                          <SelectField
                            type="select"
                            name="sector"
                            value={profileForm.sector}
                            onChange={onProfileChange}
                            error={profileErrors.sector}
                            options={sectorOptions}
                          />
                        </div>
                      </div>

                      <div className="text-center">
                        {/*<button className="btn auth-btn mb-3" disabled={disabledButton} type="submit">
                          {loading ? "Saving..." : "Save Changes"}
                        </button>*/}
                         <LoadingButton
                            type="submit"
                            buttonDisable={dLoading}
                            isLoading={loading}
                            className=""
                          >
                            Save Changes
                          </LoadingButton>
                      </div>
                    </form>
                  </div>

                  <div className="tab-pane fade pt-3" id="profile-change-password">
                    <form onSubmit={onPasswordSubmit} noValidate>
                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">Current Password</label>
                        <div className="col-md-8 col-lg-9">
                          <PasswordField
                            name="current_password"
                            value={passwordForm.current_password}
                            onChange={onPasswordChange}
                            error={passwordErrors.current_password}
                            placeholder="Enter current password"
                            type="password"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">New Password</label>
                        <div className="col-md-8 col-lg-9">
                          <PasswordField
                            name="password"
                            value={passwordForm.password}
                            onChange={onPasswordChange}
                            error={passwordErrors.password}
                            placeholder="Enter new password"
                            type="password"
                          />
                        </div>
                      </div>

                      <div className="row mb-3">
                        <label className="col-md-4 col-lg-3 col-form-label">Confirm New Password</label>
                        <div className="col-md-8 col-lg-9">
                          <PasswordField
                            name="password_confirm"
                            value={passwordForm.password_confirm}
                            onChange={onPasswordChange}
                            error={passwordErrors.password_confirm}
                            placeholder="Re-enter new password"
                            type="password"
                          />
                        </div>
                      </div>

                      <div className="text-center">
                      <LoadingButton
                          type="submit"
                          isLoading={passLoading}
                          buttonDisable={dLoading}
                          className=""
                        >
                        Change Password
                      </LoadingButton>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default UserProfile;
